module.exports = __webpack_public_path__ + "static/media/shia-intro-2.f07b42ea.mp3";